import { Link } from "react-router-dom";

export interface PressReleaseItem {
  id: number;
  title: string;
  slug: string;
  subtitle: string;
  short_description: string;
  featured_image: string;
  created_at: string;
}

interface PressReleaseCardProps {
  item: PressReleaseItem;
}

const PressReleaseCard: React.FC<PressReleaseCardProps> = ({ item }) => {
  return (
    <Link
      to={`/news/${item.slug}`}
      className="group bg-white rounded-[24px] overflow-hidden border border-gray-100 shadow-md hover:shadow-2xl hover:-translate-y-2 transition-all duration-500 flex flex-col h-full"
    >
      {/* IMAGE */}
      <div className="relative shrink-0 overflow-hidden">
        <img
          src={item.featured_image}
          alt={item.title}
          className="w-full h-48 sm:h-56 md:h-64
 object-cover group-hover:scale-110 transition duration-700"
        />
      </div>

      {/* CONTENT */}
      <div className="p-6 flex-1 flex flex-col">
        <h2 className="text-xl font-bold text-[#0A1F44] line-clamp-2 group-hover:text-blue-600 transition">
          {item.title}
        </h2>

        <p className="text-gray-600 mt-4 text-[15px] line-clamp-3">
          {item.short_description}
        </p>

        {/* DATE + READ MORE */}
        <div className="mt-auto pt-8">
          <p className="text-xs text-gray-400 mb-4">
            {new Date(item.created_at).toDateString()}
          </p>

          <div className="flex w-full flex-col items-start">
            <div className="flex items-center gap-2 text-[#0A1F44] font-semibold group-hover:text-yellow-500 transition">
              Read More
              <span className="group-hover:translate-x-1 transition duration-300">
                →
              </span>
            </div>

            <div className="h-[4px] w-full bg-gradient-to-r from-yellow-400 via-orange-400 to-yellow-500 rounded-full mt-2" />
          </div>
        </div>
      </div>
    </Link>
  );
};

export default PressReleaseCard;
